import { EditableEntity } from '../EditableEntity';

export class MemberEntityChangeRequestEntity<T> extends EditableEntity {
  entity: T | null;
  changeRequest: T;

  constructor(entity?: MemberEntityChangeRequestEntity<T>) {
    super(entity);
    if (entity) {
      Object.assign(this, { ...entity });
    } else {
      this.id = 0;
    }
  }
}
